"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlapAvatar = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var clsx_1 = __importDefault(require("clsx"));
var colors_1 = require("../colors");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    wrapper: function (props) { return ({
        height: "".concat(props.divSize, "px"),
        width: "".concat(props.divSize, "px"),
    }); },
    base: function (props) { return ({
        backgroundColor: props.borderColor ? (0, colors_1.getColor)(props.borderColor) : 'transparent',
        border: props.borderColor ? "2px solid ".concat((0, colors_1.getColor)(props.borderColor)) : "2px solid ".concat((0, colors_1.getColor)('WHITE_100')),
        height: "".concat(props.size, "px"),
        width: "".concat(props.size, "px"),
    }); },
    bottomAvatar: {
        left: 14,
        top: -24,
    },
}); });
var DEFAULT_AVATAR_URL = 'https://res.cloudinary.com/better-with-us/image/upload/c_thumb,w_200,g_face/v1621496950/avatars/no-avatar.png';
var OverlapAvatar = function (_a) {
    var _b = _a.alt, alt = _b === void 0 ? 'avatar' : _b, borderColor = _a.borderColor, className = _a.className, _c = _a.divSize, divSize = _c === void 0 ? 56 : _c, _d = _a.size, size = _d === void 0 ? 38 : _d, srcOne = _a.srcOne, srcTwo = _a.srcTwo, rest = __rest(_a, ["alt", "borderColor", "className", "divSize", "size", "srcOne", "srcTwo"]);
    var classes = useStyles({ size: size, borderColor: borderColor, divSize: divSize });
    return (react_1.default.createElement("div", { className: classes.wrapper },
        react_1.default.createElement(core_1.Avatar, __assign({ alt: alt, className: (0, clsx_1.default)(classes.base, className), src: srcOne ? srcOne : DEFAULT_AVATAR_URL }, rest)),
        react_1.default.createElement(core_1.Avatar, __assign({ alt: alt, className: (0, clsx_1.default)(classes.base, className, classes.bottomAvatar), src: srcTwo ? srcTwo : DEFAULT_AVATAR_URL }, rest))));
};
exports.OverlapAvatar = OverlapAvatar;
